// extracted by mini-css-extract-plugin
module.exports = {"like":"_vq","active":"_vr","text":"_vs"};